require('./opal');

/* Generated by Opal 1.1.1 */
(function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $hash2 = Opal.hash2, $truthy = Opal.truthy;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'ArithmeticEvaluator');

      var $nesting = [self].concat($parent_nesting);

      (function(self, $parent_nesting) {
        var $nesting = [self].concat($parent_nesting), $eval$1;

        return (Opal.def(self, '$eval', $eval$1 = function(expr, $kwargs) {
          var round_type, self = this, $ret_or_1 = nil;

          
          
          if ($kwargs == null) {
            $kwargs = $hash2([], {});
          } else if (!$kwargs.$$is_hash) {
            throw Opal.ArgumentError.$new('expected kwargs');
          };
          
          round_type = $kwargs.$$smap["round_type"];
          if (round_type == null) {
            round_type = $$$($$($nesting, 'RoundType'), 'FLOOR')
          };
          if ($truthy(expr)) {
          } else {
            return 0
          };
          if ($truthy(($ret_or_1 = $$($nesting, 'Arithmetic').$eval(expr, round_type)))) {
            return $ret_or_1
          } else {
            return 0
          };
        }, $eval$1.$$arity = -2), nil) && 'eval'
      })(Opal.get_singleton_class(self), $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
})(Opal);
